import React from 'react'
import './Fooddisplay.css';
import { food_list } from '../../assets/assets';
import Fooditem from '../Fooditem/Fooditem';
function Fooddisplay({category}) {
  return (
    <section className='foodDisplay' id='menu'>
        <div className='container'>
            <div className='row'>
                {
                    food_list.filter((item)=>{
                        if(category==="All"){
                            return item
                        }else{
                            return item.category===category
                        }
                    }).map((food_item,index)=>{
                        return(
                            <Fooditem key={index} food_item={food_item}/>
                        )
                    })
                }
            </div>
        </div>
    </section>
  )
}

export default Fooddisplay